module.exports = __webpack_public_path__ + "static/village_bg@2x-722c3d492d4c11241e8a14fb8f76977b.png";